module.exports = __webpack_public_path__ + "static/media/seniorBadge.b0211694.png";